"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getDisplayTemperature", {
    enumerable: true,
    get: function() {
        return getDisplayTemperature;
    }
});
function celsiusToFahrenheit(value) {
    return value * 9 / 5 + 32;
}
function getDisplayUnit(unit = "C") {
    const displayUnit = unit.toUpperCase()[0];
    return displayUnit === "F" ? "F" : "C";
}
function getFixedTemp(value = 0, temperatureUnit = "C") {
    if (value == null) return;
    temperatureUnit = getDisplayUnit(temperatureUnit);
    value = temperatureUnit === "F" ? celsiusToFahrenheit(value) : value;
    return Math.round(value * 10) / 10;
}
function getDisplayTemperature(value = 0, temperatureUnit = "C") {
    const displayValue = getFixedTemp(value, temperatureUnit);
    return displayValue ? `${displayValue} °${temperatureUnit}` : "";
}
